import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export const SITE = "https://krampusshow.com";

// Entfernt einmalig die statischen Fallback-Tags aus index.html (markiert mit
// data-seo-static), sobald Helmet die routenspezifischen Tags setzt – sonst Duplikate.
function useStripStaticSeo() {
  useEffect(() => {
    document.querySelectorAll("[data-seo-static]").forEach((el) => el.remove());
  }, []);
}

// Seitenbezogene SEO-Metadaten (Title, Description, Canonical, OG, Twitter, hreflang).
// path ist immer der DEUTSCHE Pfad (z.B. "/tickets"); auf /en-Routen wird er automatisch
// zur /en-URL und die Sprache der Metadaten wechselt.
export default function Seo({ title, titleEn, description, descriptionEn, path, noindex = false, jsonLd = null }) {
  const { pathname } = useLocation();
  useStripStaticSeo();
  const isEn = pathname.startsWith("/en");
  const t = isEn && titleEn ? titleEn : title;
  const d = isEn && descriptionEn ? descriptionEn : description;
  const dePath = path === "/" ? "/" : path;
  const enPath = `/en${path === "/" ? "" : path}`;
  const url = `${SITE}${isEn ? enPath : dePath}`;
  return (
    <Helmet>
      <html lang={isEn ? "en" : "de"} />
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <link rel="alternate" hrefLang="de" href={`${SITE}${dePath}`} />
      <link rel="alternate" hrefLang="en" href={`${SITE}${enPath}`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE}${dePath}`} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Latschenwirt Krampus-Show" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${SITE}/og-image.jpg`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={isEn ? "en_GB" : "de_AT"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={`${SITE}/og-image.jpg`} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
